// @flow

import Service from './service';
import type { HttpResponseType } from '../types/http-response';

export default class BlogService extends Service {
  get(options: Object = {}): Promise<string> {
    return this.api.get(`${this.baseUrl}/blog`, options)
      .then((res: HttpResponseType) => res.data);
  }
}
